// extracted by mini-css-extract-plugin
export default {"container":"R5siOy4U9N+R6jcKXde26g==","header":"x4fqM7A1tEvuLGIrlv5d3Q==","close":"pw6iohVMMr66oqtw+I4pSg==","chat":"_6T3kwqXeh6epa59MhzQVaA=="};